import React, { createContext, useContext, useState, useMemo } from "react";
import { translations } from "../i18n/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("it");

  const value = useMemo(
    () => ({
      lang,
      setLang,
      t: translations[lang],
      toggle: () => setLang((l) => (l === "it" ? "en" : "it")),
    }),
    [lang]
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
